import type { Enemy } from '../enemies';
import { wave } from '../waves';
import { ParticleSystem } from '../particles';
import { SFX } from '../audio';

interface PhaseShiftDeps {
  enemies: Enemy[];
  particles: ParticleSystem;
  triggerShockwave(x: number, y: number, dur?: number, amp?: number, wave?: number): void;
  triggerFlash(alpha: number, color?: number): void;
  shake(mag: number, dur: number): void;
}

// Detect boss / miniboss phase changes — fire banner + shockwave + flash + particle burst on each shift.
// `e.lastPhase` is mutated by the engine when the new phase is acknowledged.
export function tickBossPhaseShifts(deps: PhaseShiftDeps): void {
  for (const e of deps.enemies) {
    if (!e.alive) continue;
    if ((e.kind === 'boss' || e.kind === 'miniboss') && e.phase !== e.lastPhase) {
      const lbl = e.phase === 1 ? 'ENRAGÉ' : 'CRITIQUE';
      const tint = e.phase === 1 ? 0xff8800 : 0xff0000;
      wave.banner = { text: `BOSS ${lbl}`, color: tint, t: 90 };
      deps.triggerShockwave(e.x, e.y, 0.7, 22, 140);
      deps.triggerFlash(0.35, tint);
      deps.particles.burst(e.x, e.y, 60, e.color, 600, 1.0, Math.PI * 2, 0, 3, 7);
      SFX.boom();
      deps.shake(20, 0.5);
      e.lastPhase = e.phase;
    }
  }
}
